module.exports = __webpack_public_path__ + "static/img/uiux.b15ddd6a.jpg";